import React, {useEffect} from "react";
import Box from "@material-ui/core/Box";
import { useStyles } from "./styles";
import Container from "@material-ui/core/Container";
import Copyright from "../../../components/Footer/Copyright/index.js";
import { Redirect } from "react-router-dom";
import { Grid } from "@material-ui/core";
import {useFlags} from "launchdarkly-react-client-sdk";
import Loading from "../../../components/Loading/index.js";
import SSOAuthService from "../../../auth/sso/SSOAuthService.ts";

export default function LogoutSSOPage() {
  const classes = useStyles();
  const { systemOffline } = useFlags();
  
  const handleLogout = () => {
    let redirect = window.location.origin;
    const logouturi = localStorage.getItem('logouturi');

    if (logouturi != undefined) {
      redirect = logouturi;    
    }
    
    const authSvc = new SSOAuthService();
    authSvc.clearTokens();
    
    const allKeys = Object.keys(localStorage);
    const keysToRemove = allKeys.filter(key =>
      key.startsWith('CognitoIdentityProvider') ||
      key.startsWith('Ids.Saml') ||
      key.startsWith('lds') ||
      key === 'logouturi'
    );

    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
    
    sessionStorage.clear();
    window.location.href = redirect;
  }

  useEffect(() => {
    handleLogout();
  }, []);

  return (
    <Container component="main" maxWidth="xs" className={classes.fullHeightContainer}>
      {systemOffline?.enabled && <Redirect to={`/offline`} />}
      <div className={classes.paper}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
        >
          <img className={classes.image} src="/images/logos/a1-logo-stacked-dark.svg" />
        </Grid>
        <Loading className={classes.loadingSpinner} data-testid = "loading-spinner" />
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
